/** @format */

import {styled} from '@mui/material/styles';
import {Button, Typography} from '@mui/material';

interface RootProps {
  active: boolean;
}

export const Root = styled(Button, {
  shouldForwardProp: prop => prop !== 'active',
})<RootProps>(({theme, active}) => ({
  minWidth: '32px',
  width: 'max-content',
  height: '32px',
  borderRadius: '8px',
  background: active ? '#8ea8fd' : '#40475b',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: '0.2s',
  cursor: 'pointer',
  userSelect: 'none',
  padding: theme.spacing(0, 1),

  '&:hover': {
    background: active ? '#8ea8fd' : '#5e6b97',
  },

  '&:disabled': {
    background: '#20252f',
  },
}));

interface ValueTextProps {
  isZero: boolean;
}

export const ValueText = styled(Typography, {
  shouldForwardProp: prop => prop !== 'isZero',
})<ValueTextProps>(({theme, isZero}) => ({
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '12px',
  fontWeight: isZero ? 300 : 500,
  lineHeight: '14px',
  opacity: isZero ? 0.5 : 1,
}));
